import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { Feed } from "src/components";
import { CommentSubject } from "src/constants";
import { useSignalR } from "src/hooks";
import { queryKeys, useGetMetricFeed } from "src/http";

interface Props {
  metricGuid: string;
}

const MetricFeed = (props: Props) => {
  const { isLoading, data } = useGetMetricFeed(props.metricGuid);
  const queryClient = useQueryClient();
  const signalR = useSignalR();

  useEffect(() => {
    const handleShouldRefetchComments = (metricGuid: string) => {
      queryClient.invalidateQueries(queryKeys.metrics.getMetricFeed(metricGuid));
    };

    signalR.onShouldRefetchComments(handleShouldRefetchComments);
    return () => signalR.offShouldRefetchComments(handleShouldRefetchComments);
  }, [queryClient, signalR]);

  function invalidateMetricFeed() {
    queryClient.invalidateQueries(queryKeys.metrics.getMetricFeed(props.metricGuid));
  }

  return (
    <Feed
      subjectType={CommentSubject.Metric}
      subjectGuid={props.metricGuid}
      isLoading={isLoading}
      items={data?.feed ?? []}
      onCommentCreated={invalidateMetricFeed}
      onCommentEdited={invalidateMetricFeed}
      onCommentDeleted={invalidateMetricFeed}
    />
  );
};

export { MetricFeed };
